import { render, staticRenderFns } from "./CompanySuperAdminHub.vue?vue&type=template&id=844fc428"
import script from "./CompanySuperAdminHub.vue?vue&type=script&lang=js"
export * from "./CompanySuperAdminHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports